<template>
	<div>
		<el-link type="primary" @click="skipUrl(row)">{{ calcCount }}</el-link>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	data() {
		return {};
	},
	mixins: [mixin],
	computed: {
		calcCount() {
            return this.row.materialTagNum;
		},
	},
	methods: {
		skipUrl() {
			this.skipToMaterial(this.row);
		},
		skipToMaterial({ id, tagName }) {
			let handLink = this.$router.resolve({
				path: '/libray/local',
				query: { tagIds: id },
			});
			//标签筛选
			sessionStorage.setItem(
				'vuex_content_tag',
				JSON.stringify({
					id,
					tagName,
				}),
			);
			window.open(handLink.href, '_blank');
		},
	},
};
</script>